// 自定义指令
import Vue from 'vue';

// import dropdown from './dropdown/dropdown.vue'; (弃用)
// import dropdownMenu from './dropdown/dropdownMenu.vue'; (弃用)
// import dropdownItem from './dropdown/dropdownItem.vue'; (弃用)
import searchInput from './searchInput/index.vue';
import collapse from './Collapse/collapse.vue';
import collapseItem from './Collapse/collapseItem.vue';
import ProductLogo from './ProductLogo/index.vue';
import AvatarItem from './AvatarItem/index.vue';

// Vue.component('dropdown', dropdown); (弃用)
// Vue.component('dropdown-menu', dropdownMenu); (弃用)
// Vue.component('dropdown-item', dropdownItem); (弃用)
Vue.component('search-input', searchInput);
Vue.component('collapse', collapse);
Vue.component('collapse-item', collapseItem);
Vue.component('avatar-item', AvatarItem);
Vue.component('ProductLogo', ProductLogo);
